import { memo } from 'react';

import { useLanguage } from 'assets/languages';
import Checkbox, { ICON_TYPES } from 'components/checkbox';
import * as HELPER_CURRENCY from 'helpers/currency';
import { Settings } from 'types/settings';

export interface SelectCommissionIncreaseMaxStepProps {
  commissionPrice: number;
  amountPerStep: number;
  settings: Settings;
  maxStep: number;
  selectedValue: number;
  onChange: (step: number) => void;
}

const SelectCommissionIncreaseMaxStep = ({
  commissionPrice,
  amountPerStep,
  settings,
  maxStep,
  selectedValue,
  onChange,
}: SelectCommissionIncreaseMaxStepProps) => {
  const language = useLanguage();
  const languageTexts = { 
    ...language.common,
    ...language.pages.campaigns
  };

  if (maxStep === 0) {
    return null;
  }

  return (
    <ul className="flex flex-col items-start gap-[10px]">
      {Array.from({ length: maxStep + 1 }, (_, index) => maxStep - index).map((step) => {
        const amount = commissionPrice + amountPerStep * step;
        const amountText = HELPER_CURRENCY.makeMoneyText(
          amount,
          10000,
          (moneyText) => languageTexts._price(moneyText, HELPER_CURRENCY.getCurrencySuffixByBrand(settings)),
          (moneyText) => languageTexts._price_10000_short(moneyText, HELPER_CURRENCY.getCurrencySuffixByBrand(settings)),
        );
        const text = step >= 2 ? languageTexts.campaign_form_commission_field_increase_max_step_option_step_2(amountText)
          : step === 1 ? languageTexts.campaign_form_commission_field_increase_max_step_option_step_1(amountText)
          : languageTexts.campaign_form_commission_field_increase_max_step_option_step_0;
          
        return (
          <Checkbox
            key={`increase-step-${commissionPrice}-${step}/${maxStep}`}
            text={text}
            checked={selectedValue === step}
            type={ICON_TYPES.CIRCLE}
            onClick={() => {
              onChange(step);
            }}
          />
        );
      })}
    </ul>
  );
};

export default memo(SelectCommissionIncreaseMaxStep);
